
import { Component, Vue } from "vue-property-decorator";

import Pagination from "@/components/Pagination/index.vue";
import { OperationPointsService, OperationPointsDetailItem } from "@/api/service-proxies";
import PagedListBase, {
    PagedRequestDto
} from "@/lib/view-base/paged-list-base";
import moment from "moment";
class pointDetailPagedRequest extends PagedRequestDto {

    userId !: number
    startTime!: moment.Moment;
    endTime!: moment.Moment;
}

@Component({
    name: "totalPoint",
    components: {
        Pagination
    }
})
export default class totalPoint extends PagedListBase<
    pointDetailPagedRequest,
    OperationPointsDetailItem
> {
    request = new pointDetailPagedRequest();
    OperationPoints = new OperationPointsService()
    date = []
    pickerOptions = {
        shortcuts: [{
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近三个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
            }
        }]
    }
    created() {
        this.request.userId = Number(this.$route.query.id);
        this.refresh();
    }

    getpage(finishCallback: Function): void {
        this.OperationPoints
            .getDefailPoints(
                this.request.userId,
                this.request.startTime,
                this.request.endTime,
                this.request.skipCount,
                this.request.maxResultCount
            )
            .then(result => {

                this.list = result.items;
                this.showPaging(result);
            })
            .finally(() => {
                finishCallback();
            });
    }
    dateChange(e) {
        if (e) {
            this.request.startTime = moment(this.date[0]);
            this.request.endTime = moment(this.date[1]);
        } else {
            this.request.startTime = null;
            this.request.endTime = null;
        }
    }
    goback(){
        this.$router.back()
    }
}
